document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('#formDeliveryAreaChecker').addEventListener('submit', async function (e) {
        e.preventDefault();
        const zipcode = document.getElementById('zipcode').value;

        async function validatePostalCode(postalCode) {
            const fetchProductJSON = async function (handle) {
                const res = await fetch('/products/' + handle + '.js');
                if (!res.ok) return { error: res };
                const data = await res.json();
                return data;
            };
            const sanitizedPostalCode = postalCode.replace(/[^A-Z0-9]/gi, '');
            const initialDigits = sanitizedPostalCode.substring(0, 3);
            const deliveryAreasProduct = await fetchProductJSON('delivery-areas');
            const deliveryAreas = deliveryAreasProduct?.description?.split(',');
            const isValid =
                deliveryAreas.findIndex((el) => el.toLowerCase() === initialDigits.toLowerCase()) !== -1 ? true : false;
            return isValid;
        }

        const pass = await validatePostalCode(zipcode);
        if (pass) {
            deliveryValidator.pass();
        } else {
            deliveryValidator.fail();
        }

        return false;
    });

    const DeliveryValidatorFactory = () => {
        function OpenModal({ heading, subheading }) {
            // create a modal with text
            const modalContainer = document.createElement('div');
            const modal = document.createElement('div');
            modalContainer.id = 'modal-delivery-validator';
            modal.innerHTML = `
            <div class="modal__inner">
              <div class="modal__header">
                <h2 class="modal__title">${heading}</h2>
                <p class="modal__subtitle">${subheading}</p>
              </div>
              <div class="modal__footer">
                <button class="button button--primary" id="delivery-validator__modal__primary-action">Continue Shopping</button>
              </div>
            </div>
          `;

            const closeButton = modal.querySelector('#delivery-validator__modal__primary-action');
            closeButton.addEventListener('click', function () {
                modalContainer.remove();
            });
            modalContainer.appendChild(modal);
            document.querySelector('body').classList.add('modal--open');
            document.querySelector('body').appendChild(modalContainer);
        }
        function pass() {
            OpenModal({
                heading: '<b>Great!</b><br>We deliver to your area.',
                subheading: '<i class="fa-solid fa-circle-check"></i> Your postalcode is eligible for our Local Delivery',
            });
        }
        function fail() {
            OpenModal({
                heading: 'We do not deliver to your area.',
                subheading: 'This postalcode is not within our Local Delivery area.',
            });
        }
        return { pass, fail };
    };
    const deliveryValidator = DeliveryValidatorFactory();
});
